
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.288 0A2.8 2.8 0 001.74 1.641L.236 4.95A2.741 2.741 0 00.5 7.677c.328.459.74.82 1.198 1.077V18.2A1.8 1.8 0 003.5 20h13a1.8 1.8 0 001.8-1.8V8.756c.46-.258.873-.62 1.201-1.08.57-.796.67-1.836.265-2.727l-1.503-3.308A2.8 2.8 0 0015.712 0H4.29zM16.7 9.224a3.694 3.694 0 01-2.634-.887l-.531-.455c-.161.14-.354.294-.575.448-.693.486-1.729 1.02-2.958 1.02-1.23 0-2.266-.534-2.96-1.02a7.14 7.14 0 01-.574-.448l-.53.455a3.694 3.694 0 01-2.638.887V18.2c0 .11.09.2.2.2H7V15a3 3 0 116 0v3.4h3.5a.2.2 0 00.2-.2V9.224zM3.196 2.304A1.2 1.2 0 014.288 1.6h11.425a1.2 1.2 0 011.092.703l1.504 3.308c.168.371.126.804-.11 1.136a2.112 2.112 0 01-3.093.375l-1.692-1.45-.52.606-.007.008-.038.042a5.553 5.553 0 01-.807.692c-.557.39-1.271.73-2.041.73s-1.485-.34-2.042-.73a5.544 5.544 0 01-.845-.734l-.008-.009-.519-.605-1.692 1.45a2.112 2.112 0 01-3.092-.375 1.141 1.141 0 01-.11-1.136l1.503-3.308zM11.4 18.4V15a1.4 1.4 0 10-2.8 0v3.4h2.8z"}})])
          )
        }
      }
    